import React, { useState } from "react";

import { Switch, FormControlLabel, FormGroup } from "@mui/material";

import useUiStore from "../../../../stores/useUiStore";

const Switches = () => {
  const { paramsFragments, setParamsFragments } = useUiStore();

  const MySwitch = (props) => {
    const { field, value, ...previousProps } = props;
    const { label } = previousProps;

    const [localValue, setLocalValue] = useState(value);

    const handleValue = (e) => {
      setLocalValue(e.target.checked);

      setParamsFragments({
        ...paramsFragments,
        [field]: { ...previousProps, value: !value },
      });
    };

    return (
      <FormControlLabel
        control={
          <Switch size="small" checked={localValue} onChange={handleValue} />
        }
        label={label}
      />
    );
  };

  return (
    <FormGroup>
      {Object.keys(paramsFragments).map((item, index) => (
        <MySwitch key={index} field={item} {...paramsFragments[item]} />
      ))}
    </FormGroup>
  );
};

export default Switches;
